'use strict';
const textOnlyFonts = {
		'Sans': `NotoSans, 'Helvetica Neue', Roboto, Helvetica, Arial, sans-serif`,
		'Serif': 'NotoSerif, serif',
		'Mono': 'NotoSansMono, monospace',
		'Marker': 'Nothing You Could Do',
		'Thick Marker': 'Permanent Marker',
		'Hand Writing': 'Rock Salt',
		'Stencil': 'Saira Stencil One',
		'Comic': 'Love Ya Like A Sister',
		'Block': 'Londrina Solid'
	},
	stickerFonts = {
		'emoji': 'system-ui, emoji, System Emoji, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Emoji'
	};

module.exports = function fontFamilies(options) {
	if (options && options.textFontOnly) {
		return textOnlyFonts;
	}
	return Object.assign({}, textOnlyFonts, stickerFonts);
};



